var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisselectedAuditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9707 18 18 13.9707 18 9C18 4.0293 13.9707 0 9 0C4.0293 0 0 4.0293 0 9C0 13.9707 4.0293 18 9 18ZM12.6 9.675C12.779 9.675 12.9507 9.60388 13.0773 9.4773C13.2039 9.35071 13.275 9.17902 13.275 9C13.275 8.82098 13.2039 8.64929 13.0773 8.5227C12.9507 8.39612 12.779 8.325 12.6 8.325H5.4C5.22098 8.325 5.04929 8.39612 4.9227 8.5227C4.79612 8.64929 4.725 8.82098 4.725 9C4.725 9.17902 4.79612 9.35071 4.9227 9.4773C5.04929 9.60388 5.22098 9.675 5.4 9.675H12.6Z",
    fill: "#F02D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisselectedAuditIcon);
export default __webpack_public_path__ + "static/media/disselected_audit_icon.0c4533e3ca3ca702f66c6b79db161476.svg";
export { ForwardRef as ReactComponent };